/**
 * Logout.jsx
 * Tatalli Cloud — Oturum Kapatma Bileşeni
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem('currentSession');
    setTimeout(() => {
      window.location.href = '/portal/login';
      navigate('/portal/login');
    }, 100);
  }, [navigate]);

  return null;
};

export default Logout;
